import o from "./index49.js";
function c(e) {
  let t = 0, n = e.length;
  for (; t < n; ) {
    const r = e.charCodeAt(t);
    if (r !== 9 && r !== 32)
      break;
    t += 1;
  }
  for (; n > t; ) {
    const r = e.charCodeAt(n - 1);
    if (r !== 9 && r !== 32)
      break;
    n -= 1;
  }
  return t === 0 && n === e.length ? e : e.slice(t, n);
}
const u = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), a = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function i(e, t) {
  return o.isArray(e) ? e.map((n) => i(n, t)) : c(String(e).replace(t, ""));
}
const l = (e) => i(e, u), f = (e) => i(e, a);
function E(e) {
  const t = /* @__PURE__ */ Object.create(null);
  return o.forEach(e.toJSON(), (n, r) => {
    t[r] = f(n);
  }), t;
}
export {
  f as sanitizeByteStringHeaderValue,
  l as sanitizeHeaderValue,
  E as toByteStringHeaderObject
};
